<template lang="pug">
.card-inteligencia-territorial-dados-gerais-imoveis
    .card-inteligencia-territorial-imoveis-interno--texto
        .card-inteligencia-territorial-imoveis-interno--titulo(
            style='width: 100%'
        ) {{ $t('mensagens.inteligenciaTerritorial.imovel.totalAreaPlantada') }}
            .card-inteligencia-territorial-imoveis-interno--valor
                span.conteudo-informativo.red {{ formatoNumero(0) }} ha
    .card-inteligencia-territorial-imoveis-interno--colunas.ml-2
        .card-inteligencia-territorial-imoveis-interno--texto
            div(style='width: 25%')
                .separador-personalizado
            div(style='width: 25%')
                .separador-personalizado
            div(style='width: 25%')
                .separador-personalizado
            div(style='width: 25%')
                .separador-personalizado

    .card-inteligencia-territorial-imoveis-interno--colunas.ml-2
        .card-inteligencia-territorial-imoveis-interno--texto
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 25%'
            ) {{ $t('mensagens.inteligenciaTerritorial.imovel.lavourasTemporarias') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 25%'
            ) {{ $t('mensagens.inteligenciaTerritorial.imovel.lavourasPerenes') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 25%'
            ) {{ $t('mensagens.inteligenciaTerritorial.imovel.sivicultura') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 25%'
            ) {{ $t('mensagens.inteligenciaTerritorial.imovel.mosaicosUso') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 25%'
            ) {{ $t('mensagens.cultura.SOJA') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo-menor {{ formatoNumero(areaTotal.areaPlantadaUltimaSafraSojaHa) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 75%'
            ) {{ $t('mensagens.cultura.CAFE') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo-menor.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 25%'
            ) {{ $t('mensagens.cultura.canaAcucar') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo-menor.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 75%'
            ) {{ $t('mensagens.cultura.citrus') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo-menor.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 25%'
            ) {{ $t('mensagens.cultura.ALGODAO') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo-menor.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 75%'
            ) {{ $t('mensagens.cultura.dende') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo-menor.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 25%'
            ) {{ $t('mensagens.cultura.arroz') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo-menor.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 25%; max-width: 120px'
            ) {{ $t('mensagens.inteligenciaTerritorial.imovel.outrasLavourasPerenes') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo-menor.red.mb-0 {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(style='width: 50%')
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 25%; max-width: 120px'
            ) {{ $t('mensagens.inteligenciaTerritorial.imovel.outrasLavourasTemporarias') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo-menor.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(style='width: 75%')
</template>
<script>
import formatters from '@/utils/formatters';

export default {
    name: 'CardInteligenciaTerritorialPotencialAgropecuarioImovel',
    props: {
        areaTotal: {
            type: Object,
            default: () => {
            }
        }
    },

    data() {
        return {};
    },

    methods: {
        formatoNumero(number) {
            return number ? formatters.formatNumber(number, 2) : 0;
        }
    }
};
</script>
<style lang="scss" scoped>
.card-inteligencia-territorial-dados-gerais-imoveis {
    height: 550px;
    border-radius: 8px;
    background: var(--white);
    padding: 7px 15px;
    color: var(--primary);
    box-shadow: 0px 0px 10px 0px #0000001A;

    .card-inteligencia-territorial-imoveis-interno--colunas {
        display: flex;
        justify-content: flex-start;
    }

    .card-inteligencia-territorial-imoveis-interno--titulo {
        padding-top: 0px;
        font-size: 16px;
        font-weight: 400;
        flex-wrap: wrap;
        margin-top: 10px;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
    }

    .card-inteligencia-territorial-imoveis-interno--texto {
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        margin-left: 12px;
        width: 100%;
        color: #3B3B3B;

        span {
            margin-top: 6px;
        }

        .recuo-avancado {
            margin-left: 8px;
        }
    }

    .card-inteligencia-territorial-imoveis-interno--valor {
        display: flex;
        padding-top: 1px;
        margin-bottom: 5px;
    }

    .separador-personalizado {
        border: 2px;
        width: 45px;
        height: 2px;
        border-top: 3px solid var(--secondary-two);
    }

    .conteudo-informativo {
        font-size: 18px;
        font-weight: 500;
        line-height: 21px;
        letter-spacing: 0em;
        margin-bottom: 10px;
        color: var(--primary);
    }

    .conteudo-informativo-menor {
        font-size: 16px;
        font-weight: 500;
        line-height: 21px;
        letter-spacing: 0em;
        margin-bottom: 10px;
        color: var(--primary);
    }

    .red {
        color: red;
    }
}
</style>
